import { ApiPath } from '@common/app/api-path';
import {
  type ClaimAllGoodsResponseType,
  type ClaimGoodsByIdResponseType,
  type ClearWorkshopProductionResponseType,
  type GetWorkshopResponseType,
  type PutToWorkshopRequest,
} from '@common/types/query/workshop';
import { type UserWorkshop } from '@common/types/workshopType';

import { api } from '../base';

const workshopApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWorkshop: builder.query<GetWorkshopResponseType, void>({
      query: () => ApiPath.GET_WORKSHOP,
      keepUnusedDataFor: 0,
      providesTags: ['BOOST', 'WORKSHOP'],
    }),
    buildWorkshop: builder.mutation<UserWorkshop[], { id: string }>({
      query: ({ id }) => ({
        url: ApiPath.BUILD_WORKSHOP + id,
        method: 'POST',
      }),
      invalidatesTags: ['WORKSHOP'],
    }),
    upgradeWorkshop: builder.mutation<UserWorkshop, { id: string }>({
      query: ({ id }) => ({
        url: ApiPath.BUILD_WORKSHOP + id,
        method: 'PATCH',
      }),
      invalidatesTags: ['WORKSHOP'],
    }),
    putToWorkshop: builder.mutation<UserWorkshop, PutToWorkshopRequest>({
      query: (body) => ({
        url: ApiPath.WORKSHOP,
        method: 'PUT',
        body,
      }),
    }),
    clearWorkshopProduction: builder.mutation<
      ClearWorkshopProductionResponseType,
      { id: string }
    >({
      query: ({ id }) => ({
        url: ApiPath.WORKSHOP + `/${id}/clear`,
        method: 'POST',
      }),
    }),
    claimAllGoods: builder.mutation<ClaimAllGoodsResponseType, void>({
      query: () => ({
        url: ApiPath.CLAIM_ALL_GOODS,
        method: 'POST',
      }),
    }),
    claimGoodsById: builder.mutation<
      ClaimGoodsByIdResponseType,
      { id: string }
    >({
      query: ({ id }) => ({
        url: ApiPath.CLAIM_GOODS + id,
        method: 'POST',
      }),
    }),
  }),
});

const {
  useGetWorkshopQuery,
  useBuildWorkshopMutation,
  useUpgradeWorkshopMutation,
  useClaimAllGoodsMutation,
  useClaimGoodsByIdMutation,
  usePutToWorkshopMutation,
  useClearWorkshopProductionMutation,
  useLazyGetWorkshopQuery,
} = workshopApi;

export {
  useBuildWorkshopMutation,
  useClaimAllGoodsMutation,
  useClaimGoodsByIdMutation,
  useClearWorkshopProductionMutation,
  useGetWorkshopQuery,
  useLazyGetWorkshopQuery,
  usePutToWorkshopMutation,
  useUpgradeWorkshopMutation,
  workshopApi,
};
